import _ from '@lodash';
import { TableCell, Tooltip } from '@material-ui/core';
import { withRouter } from 'react-router';
import { format } from 'date-fns';

function TaskManagerStateField(props) {
	const { item } = props;

	const getLabel = () => {
		if (!item || !item.state || !item.state.lastDateTime) return '-';
		return format(new Date(item.state.lastDateTime), 'yyyy.MM.dd. HH:mm')
	};

	return (
		<TableCell className='w-auto'>

			<Tooltip title={getLabel()} placement='bottom'>
				<div className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{getLabel()}</div>
			</Tooltip>

		</TableCell>
	);
}

export default withRouter(TaskManagerStateField);